import { ComposerExtensionConfig, ComposerModuleName } from '../@types/index.js'

export const SupportedAudioFormats = ['audio/mpeg', 'audio/ogg', 'audio/wav']
export const SupportedVideoFormats = ['video/mp4']
export const SupportedMediaFormats = [
  ...SupportedAudioFormats,
  ...SupportedVideoFormats,
]

export const EMBED_INPUT_CLASS = `${ComposerModuleName.Embed}-input`

export const DefaultExtensionConfig: ComposerExtensionConfig = {
  heading: true,
  mention: true,
  embed: true,
  attachment: true,
  image: true,
  emoji: true,
  video: true,
  code: true,
  list: true,
  table: true,
  tableOfContents: true,
  formatting: {
    bold: true,
    italic: true,
    underline: true,
    strikethrough: true,
  },
  poll: true,
  event: true,
}
